import { useState , useMemo } from 'react'

import GenericGrid from '../../../components/grid/grid'

import { renderColumns } from '../../../utils/helper'

const dummayData = [
    { name:"Open Ai" , product:"ChatGpt" , model:"5.2" , lastRun:"20-01-2026" , id:1 , status:true },
    { name:"Anthropic" , product:"Clude" , model:"Opus 4.6" , lastRun:"22-01-2026" , id:2 , status:true },
    { name:"Google" , product:"Gemini" , model:"3 Pro" , lastRun:"23-01-2026" , id:3 , status:false },
]

const General = () => {
    const [ data , setData ] = useState ( dummayData )

    const [dataState, setDataState] = useState({
      skip: 0,
      take: 100,
      sort: [],
      filter: null
    });

const handleSelectionChange = (event) => {
  const newData = data.map(item => ({
    ...item,
    selected: item.id === event.dataItem.id
  }));

  const selectedItem = newData.find( item => item.selected )

  setData(newData);

  localStorage.setItem( "studies_general_row" , JSON.stringify( selectedItem ? selectedItem : {} ) )

};

const handleDataStateChange = (e) => {
  setDataState(e.dataState);
};

  const columns = useMemo(() => [
    {
      title: "Model",
      field: "name"
    },
    {
      title: "",
      field: "product",
      headerCell: () => <th style={{ display: "none" }}></th>
    },
    {
      title: "",
      field: "model",
      headerCell: () => <th style={{ display: "none" }}></th>
    },
    {
      title: "Last Run",
      field: "lastRun"
    },
    {
      title: "Status",
      field: "",
      cell: (prop) => {
        console.log(prop, "prop,,");
        return (
          <td>
            { 
                prop.dataItem?.status ? 
               <i class="fas fa-check-circle text-success" style={{color:"green"}} ></i> :
               <i class="fas fa-times-circle text-danger" style={{color:"red"}}></i>
            }
          </td>
        );
      }
    }
  ], []);


  return (
    <div>
        <GenericGrid
         data={data}
         columns={renderColumns(columns)}
         dataState={dataState}
         onDataStateChange={handleDataStateChange}
         pageable={false}
         sortable={false}
         filterable={false}
         style={{ height:"100%" , minWidth:"500px" }}
         dataItemKey = { "id" }
         selectable={{
                        enabled: false,
                        mode: "single",
                        drag: false,
                        cell: false}}
         onSelectionChange={handleSelectionChange}
         storageField = {"studies_general_row"}
         />
    </div>
  )
}

export default General